export default __webpack_public_path__ + "static/media/logo-new@2x.f9c2fbd1.png";